import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { PagesModule } from "@root/router/pages.module";
import { ACLGuard } from "@delon/acl";
import { PreloadingStrategyService } from "./preloading-strategy";
const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "app/dashboard",
  },
  {
    path: "app",
    children: [
      //#region 登录
      // { path: 'passport', loadChildren: () => import('@root/router/passport/passport.module').then(m => m.PassportModule) }, // 登录的替代页面，暂时未完成，所以先不使用
      { path: "login", loadChildren: () => import("@root/router/login/login.module").then((m) => m.LoginModule) },
      {
        path: "register",
        loadChildren: () => import("@root/router/register/register.module").then((m) => m.RegisterModule),
      },
      //#endregion

      //#region company
      {
        path: "company",
        loadChildren: () => import("@root/router/company/company.module").then((m) => m.CompanyModule),
        canLoad: [ACLGuard],
        data: { guard: { role: ["company_master"] }, guard_url: "/app/calendar" },
      },
      //#endregion

      //#region 外部页面 - 客服
      {
        path: "iframe/customer-service",
        loadChildren: () => import("@root/router/iframe/iframe.module").then((m) => m.IframeModule),
      },
      //#endregion

      //#region 限时活动页面
      {
        path: "activity",
        loadChildren: () => import("@root/router/activity/activity.module").then((m) => m.ActivityModule),
      },
      //#endregion

      //#region 主页面和错误页面
      {
        path: "",
        loadChildren: () => import("@root/router/index/index.module").then((m) => m.IndexModule),
        canLoad: [ACLGuard],
        data: {
          guard: {
            role: ["company_master"],
            except: true,
          },
          guard_url: "/app/company/dashboard",
        },
      },

      { path: "**", loadChildren: () => import("@root/router/error/error.module").then((m) => m.ErrorModule) },
      //#endregion
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    PagesModule,
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: PreloadingStrategyService,
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRouteModule {}
